import { FunctionComponent } from "react";
import BasicButton from "@components/core/buttons/BasicButton";
import BasicModal from "@components/core/modals/BasicModal";
import { useTranslation } from "react-i18next";

interface ConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
  title: string;
  content?: string | JSX.Element | JSX.Element[];
  okText?: string;
  cancelText?: string;
  className?: string;
}

const ConfirmModal: FunctionComponent<ConfirmModalProps> = ({
  visible,
  onCancel,
  onOk,
  title,
  content,
  okText,
  cancelText,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      visible={visible}
      onCancel={onCancel}
      onOk={onCancel}
      title={title}
      closable={false}
      footer={
        <div className="modal-footer-buttons">
          <BasicButton
            variant="secondary"
            text={cancelText ? cancelText : t("buttons.no")}
            onClick={onCancel}
          />
          <BasicButton
            variant="primary"
            text={okText ? okText : t("buttons.yes")}
            onClick={onOk}
          />
        </div>
      }
      className={`app-modal-confirm ${
        !!content ? "" : "modal-empty"
      } ${className}`}
    >
      <>{content}</>
    </BasicModal>
  );
};

export default ConfirmModal;
